import { Component, Injector, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { JkPopup, openWinClass, PageKind, TitlebarComponent } from 'jk-service';
import {
  CellValueChangedEvent,
  ColDef,
  ColTypeDef,
  GridApi,
  RowClickedEvent,
  RowDoubleClickedEvent,
  RowSelectedEvent,
} from 'ag-grid-community';
import { jkBaseForm } from 'jk-service';
import { jkRestReturn, } from 'jk-service';
import { JkgridwinComponent } from './jkgridwin/jkgridwin.component';
import { viewChild } from '@angular/core';

@Component({
  template: '',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    // Host bindings will be added here if needed
  }
})
export class jkQueryComponent extends jkBaseForm {
  isBrowse: boolean = true;
  //titlebarCom = viewChild<TitlebarComponent>('titlebar'); 祖先有
  openwin: openWinClass = new openWinClass();
  masterGrid!: JkgridwinComponent; // FIXME: = viewChild<JkgridwinComponent>('jkgridwin');
  /*get masterGridValue() {
    return this.masterGrid;
  }*/
  _gridStyle: any = {
    width: '100%',
    height: '100%',
    flex: '1 1 auto',
  };

  get gridStyle(): any {
    return this._gridStyle;
  }
  set gridStyle(value: any) {
    /*if (!value) {
      if (this.masterGrid) {
        value = this.masterGrid.gridStyle;
      }
    }*/
    this._gridStyle = value;
    //this.ref.detectChanges();
  }
  columnTypes!: { [key: string]: ColTypeDef };
  set gridApi(value: GridApi) {
    const grid = this.masterGrid;
    if (grid?.gridSrv) grid.gridSrv.gridApi = value;
    else alert('jkaggrid.gridSrv is null');
  }
  get gridApi(): GridApi {
    const grid = this.masterGrid;
    return grid!.gridApi;
  }
  resort() {
    const grid = this.masterGrid;
    grid?.gridSrv.resort();
  }
  //onGridReady(params: any) {
  //}
  afterGridReady($event: JkgridwinComponent) {
    this.masterGrid = $event;
    this.gridApi = $event.gridApi;
    this.masterGrid.gridSrv.init(this.gridInitOpt);
    this.initTabGroup();

  }

  onCellValueChanged($event: CellValueChangedEvent<any, any>) { }
  onRowSelected($event: RowSelectedEvent<any, any>) {
    // 會跑兩次. 一次是選取, 一次是取消選取
  }
  override onAfterScroll(item: any, ret: jkRestReturn): void {
    super.onAfterScroll(item, ret);

  }

  agRowClicked($event: RowClickedEvent<any, any>) { // RowClickedEvent<any, any>

  }

  gridWidth: number = window.innerWidth - 10;
  //masterStore: any;
  useCache = false;
  //qryMaster: JkEntityV2;
  //dsMaster: any;
  get mainTable(): string {
    const grid = this.masterGrid;
    if (!grid) {
      alert('get mainTable:masterGrid 未設定');
      return '';
    }
    //return grid.openwinIn.mainTable.toUpperCase();
    return this.openwin.mainTable;
  }
  set mainTable(value: string) {
    const grid = this.masterGrid;
    if (!grid) {
      alert('set mainTable:masterGrid 未設定');
      return;
    }
    //grid.openwinIn.mainTable = value.toUpperCase();
    this.openwin.mainTable = value.toUpperCase();
  }
  get winItem(): string {
    const grid = this.masterGrid;
    if (!grid) {
      alert(' get winItem:masterGrid 未設定');
      return '';
    }
    return this.openwin.item;
  }
  set winItem(value: string) {
    const grid = this.masterGrid;
    if (!grid) {
      alert('set winItem:masterGrid 未設定:' + value);
      return;
    }
    this.openwin.item = value;
  }
  get params(): any {

    if (!this.masterGrid) {
      alert('get params:masterGrid 未設定');
      return undefined;
    }
    return this.openwin.params;
  }
  set params(value: any) {
    const grid = this.masterGrid;
    if (!grid) {
      alert('set params:masterGrid 未設定');
      return;
    }
    this.openwin.params = value;
  }
  get item(): any {
    const grid = this.masterGrid;
    if (!grid) {
      alert('get item:masterGrid 未設定');
      return undefined;
    }

    if (grid.gridSrv.rowIndex) {
      if (grid.gridSrv.rowIndex !== grid.focusedRowIndex) {
        alert('rowIndex !== focusedRowIndex');
      }
      return grid.itemList[grid.gridSrv.rowIndex];
    }
    else
      return undefined;
  }
  get itemList(): any[] {
    const grid = this.masterGrid;
    if (!grid) {
      //alert('masterGrid 未設定');
      return [];
    }
    return grid.itemList;
  }
  set itemList(value) {
    const grid = this.masterGrid;
    if (!grid) {
      alert('set itemList:masterGrid 未設定');
      return;
    }
    grid.setItemList(value); //.set(value);
  }
  get type(): string {
    const grid = this.masterGrid;
    if (!grid) {
      alert('get type:masterGrid 未設定');
      return '';
    }
    return this.openwin.type;
  }
  set type(value: string) {
    //const grid = this.masterGrid;
    //if(!grid) return;
    this.openwin.type = value;
  }
  get sqlSelect(): string {
    //const grid = this.masterGrid;
    return this.openwin.sqlSelect;
  }
  set sqlSelect(value: string) {
    //const grid = this.masterGrid;
    //if(grid) grid.openwinIn.sqlSelect = value;
    this.openwin.sqlSelect = value;
  }
  get where(): string {
    return this.openwin.where || '';
  }
  set where(value: string) {
    this.openwin.where = value;
  }
  get order(): string {
    return this.openwin.order || '';
  }
  set order(value: string) {
    this.openwin.order = value;
  }
  get PS(): string {
    return this.openwin.PS || '';
  }
  set PS(value: string) {
    this.openwin.PS = value;
  }
  get display(): string {
    return this.openwin.display || '';
  }
  set display(value: string) {
    this.openwin.display = value;

  }
  get itemFocused(): any {
    const grid = this.masterGrid;
    if (!grid || !grid.itemFocused) {
      return {};
    }
    return grid.itemFocused;
  }
  set itemFocused(value: any) {
    const grid = this.masterGrid;
    if (grid) {
      grid.itemFocused = value;
    }
  }
  override async init2() {
    super.init2();
  }
  popFilter: JkPopup; // query form
  onPopFilterOk?: (e: any) => void; // doOk callback

  constructor() {
    super(inject(Injector));
    this.pageKind = PageKind.query;
    this.popFilter = new JkPopup();
  }
  override ngOnInit() {
    super.ngOnInit();
    this.getLookup();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    await this.constructorInit();
  }

  async constructorInit(): Promise<void> {
    await this.setFormOpt2(this.title); //###
  }

  popFilterShow(e: any) {
    this.popFilter.popupVisible = true;
  }
  popFilterOk(e: any) {
    if (this.onPopFilterOk) {
      this.onPopFilterOk(e);
    }
    this.popFilter.popupVisible = false;
  }
  popFilterHide(e: any) {
    this.popFilter.popupVisible = false;
  }
  popFilterOkOption = {
    //icon:'check',
    type: 'default', //  'back' | 'danger' | 'default' | 'normal' | 'success'
    text: '🆗 確定',
    onClick: (e: any) => {
      this.popFilterOk(e);
    },
  };
  popFilterCancelOption = {
    type: 'danger',
    //icon:'close',
    text: '❌ 取消',
    onClick: (e: any) => {
      this.popFilterHide(e);
    },
  };

  override onWindowResize() {
    // ###
    super.onWindowResize();
    this.popFilter.popUpWidth = window.innerWidth - this.popFilter.WidthBorder;
  }
  //async doQuery(where?: string, order?: string, params?: any[]) {
  async doQuery() {
    this.power.checkPower(this.programId, this.login, 'query');
    this.masterTabGroupIndex = 0;

    await this.showLoadingView({ showOverlay: true });

    let bool = await this.beforeQuery();
    if (bool) {

      if (!this.masterGrid) {
        alert('doQuery:masterGrid 未設定');
      } else {
        this.masterGrid.openwin(this.openwin);
        this.onAfterQuery(this.item, this.ret);
      }
    } else {
      //alert('beforeQuery return false');
    }
    await this.dismissLoadingView();
  }
  async beforeQuery(): Promise<boolean> {
    this.power.checkPower(this.programId, this.login, 'query');
    return true;
  }
  override onAfterQuery(item: any, ret: any) {
    super.onAfterQuery(item, ret);
    this.masterTabGroupIndex = 1;

  }
  override async doRefresh() {
    super.doRefresh();
    await this.showLoadingView({ showOverlay: true });

    //super.refreshData(tableName);
    const grid = this.masterGrid;
    if (grid) {
      // await grid.doRefresh();
      grid.doQuery();
    }
    // ===== or =====
    //let dataGridDataSource = this.dataGrid.instance.getDataSource();
    //dataGridDataSource.load();
    await this.dismissLoadingView();
  }
  /*doRefreshOption = {
    accessKey: 'R',
    hint: 'Alt-R:重查資料',
    visible: true,
    icon: 'refresh',
    text: '重查資料',
    onClick: () => {
      this.masterGrid.doRefresh();
    },
  };*/
  quickFilter(value: string) {
    const grid = this.masterGrid;
    if (grid?.gridApi) {
      grid.gridApi.setGridOption('quickFilterText', value);
    }
  }

  doGetPreFilter() {
    // TODO:
  }
  agRowDoubleClicked($event: RowDoubleClickedEvent<any, any>) {
    /*if (this.isMultiSelect) {
      this.selectedItem = $event.data;
    } else {
      this.selectedItem = $event.data;
    }
    if(this.doubleClick){
      this.doubleClick.emit($event);
    }*/
  }
  gridColumnLimits = []; // [{ key: "country", minWidth: 900 }];
  sizeToFit() {
    const grid = this.masterGrid;
    if (grid?.gridApi) {
      grid.gridApi.sizeColumnsToFit({
        defaultMinWidth: 50,
        columnLimits: this.gridColumnLimits,
      });
    }
  }
  /*doFilterClick() {
  this.popFilter.popupVisible = true;
}
async popUpOk(e) {
  this.popFilter.popupVisible = false;
  //this.qryMaster.urlParam = `?kind=everyday&platform=['moondear','momo','shopee']&date1=${this.date1}&date2=${this.date2}`;
  //this.qryMaster.urlParam = this.getUrlParam();
  this.masterGrid.getUrlParam();
  await this.masterGrid.doRefresh();
}
popUpCancel(e) {
  this.popFilter.popupVisible = false;
}*/
}
